import { render, staticRenderFns } from "./secondProduct.vue?vue&type=template&id=3ed65ed0&scoped=true&"
import script from "./secondProduct.vue?vue&type=script&lang=js&"
export * from "./secondProduct.vue?vue&type=script&lang=js&"
import style0 from "./secondProduct.vue?vue&type=style&index=0&id=3ed65ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed65ed0",
  null
  
)

export default component.exports